module.exports = [
  ['st', 'saint']
]

